import { CxEvent } from '@spartacus/core';

export class Ga4GgNewsletterSubscriptionSuccessEvent extends CxEvent {
  event?: string;
  visitor_type?: string;
}
